import { css } from "@emotion/react";

export const iconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  margin-left: 0.5rem;
  height: 100%;
`;
